import React from 'react';
import _ from "lodash";
import { Row, Col, Label  } from "reactstrap";
import FormInput from '../../../../comum/components/FormInput';
import FormInputNumber from '../../../../comum/components/FormInputNumber';
import FormInputLacre from '../../../../comum/components/FormInputLacre';
import FormSelect from '../../../../comum/components/FormSelect';
import { inject, observer } from "mobx-react";
import { isInvalidoTam5 } from '../../../../../utils/validadores';
import { sanitizarCnpj } from '../../../../../utils/sanitizar';
import { IconeDelete } from '../../../../comum/components/Icones';
import CardBookingContainersStore from "../stores/CardBookingContainersStore";
import CheckboxField from '../../../../comum/components/CheckboxField';
import { valida } from "../../../../principal/containers/Valida"

@inject("store")
@observer
export default class CardBookingContainers extends React.Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.parametrosStore = this.props.store.parametrosStore;
        this.controller = new CardBookingContainersStore(this.props.tipoAgenda);
        this.bookingController = this.props.controller;

        this.sobremedidaBloqueado = true;

        this.state = {
            atualizado: true,
            lacresMarcados: [],
            iso: null,
            capacidademax: null,
            pesodocumental: null,
            tara: null,
            cliente: null,
            categoria: null,
            tipoMercadoria: null
        };
    };

    componentDidMount() {
        if (!process.env.rig) {
            this.bookingController.carregarTiposDeContainer(this.props.booking.NumBooking);
            this.bookingController.carregarISOs(_.get(this.props.container, 'CdTipoCntr'), this.props.booking.NumBooking);
        } else {
            setTimeout(() => {
                if (_.get(this.props.container, 'CdIso')) {
                    this.controller.validarISOCarregarMercadorias(_.get(this.props.container, 'CdIso'), this.props.dado, this.props.setDadosAgendamentoSemPensar);
                }
            }, 2000);
        }

        if(["ECC","ECCM","ECV", "23ECV"].includes(this.props.tipoAgenda.codIdentificador))
            this.bookingController.carregarCategorias(this.props.booking.LcCdLoc);

        this.revisaListasTiposLacres();

        this.alterarBloqueioTiposMercadoria(_.get(this.props.container, 'CdTipoMerc'));
        this.controller.setTransitoAduaneiro(_.get(this.props.container, 'FlgTran'));

        this.props.setStatusSalvo(false);

        if (!this.props.isEditar) {
            let lacres = _.get(this.props.container, `Lacres`);
            if (lacres.length === 0) {
                this.props.adicionarLacre();
            }
            this.setDadosMercadoria();
        }
        else {
            this.setCamposObrigatorios();
            this.handleCarregarClientes(this.props.container.CnpjCliente, false);
            if (process.env.ssa)
                this.handleCarregarRespOva(this.props.container.CnpjRespOva, false);
        }
        if (this.props.ncmAtivo && this.parametrosStore.isAgendamentoVisible("ListaContainerNCM")) {
            this.handleBlurNCM();
        }

    };

    setCamposObrigatorios() {
        let aux = _.get(this.props.container, `ValPesoDoc`);

        if (this.props.container) {
            this.setState({
                ...this.state,
                lacresMarcados: _.get(this.props.container, `Lacres`) != undefined ? _.get(this.props.container, `Lacres`) : null,
                iso: _.get(this.props.container, `CdIso`) != undefined ? _.get(this.props.container, `CdIso`) : null,
                capacidademax: _.get(this.props.container, `ValPesoMax`) != undefined ? _.get(this.props.container, `ValPesoMax`) : null,
                pesodocumental: _.get(this.props.container, `ValPesoDoc`) != undefined ? _.get(this.props.container, `ValPesoDoc`) : null,
                tara: _.get(this.props.container, `ValTara`) != undefined ? _.get(this.props.container, `ValTara`) : null,
                cliente: _.get(this.props.container, `CnpjCliente`) != undefined ? _.get(this.props.container, `CnpjCliente`) : null,
                categoria: _.get(this.props.container, `Categoria`) != undefined ? _.get(this.props.container, `Categoria`) : null,
                tipoMercadoria: _.get(this.props.container, `CdTipoMerc`) != undefined ? _.get(this.props.container, `CdTipoMerc`) : null
            });
        }
    }

    setDadosMercadoria() {
        this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.ValTmpIdea`, _.get(this.props.container, `ValTmpIdea`));
        this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.ValUmid`, _.get(this.props.container, `ValUmid`));
        this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.ValVent`, _.get(this.props.container, `ValVent`));
        this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.IdUn`, _.get(this.props.container, `IdUn`));
    }

    handleChangeTipoCntr = (campo, event) => {
        if (event != null)
            this.bookingController.carregarISOs(event.value, this.props.booking.NumBooking);
        else {
            this.handleChangeISO(campo.replace('CdTipoCntr', 'CdIso'), event)
            this.bookingController.carregarISOs(event, this.props.booking.NumBooking);
        }
        this.props.setDado(campo, event);
    };

    handleCarregarClientes = (cnpj, emiteMsg = true) => {
        this.bookingController.carregarClientes(cnpj, this.props.dado, this.props.setDadosAgendamentoSemPensar, process.env.rig, emiteMsg);
    };

    handleCarregarRespOva = (cnpj, salvarDados = true) => {
        this.bookingController.carregarRespOva(cnpj, this.props.dado, this.props.setDadosAgendamentoSemPensar, process.env.rig, this.props.index, salvarDados);
    };

    handleBlurNCM = () => {
        this.bookingController.carregarMercadoria(this.props.container.IdCommoditie, this.props.dado, this.props.setDadosAgendamentoSemPensar);
    };

    handleChangeISO = (campo, event) => {
        this.props.setDado(campo, event);
        this.bookingController.carregarTiposMercadorias(_.get(event, "value"))

        this.setState({
            iso: (event != null ? event.value : null)
        });
    };

    handleBlurISO = async (campo, event) => {
        this.props.setDado(campo, event);
        this.controller.validarISOCarregarMercadorias(_.get(event, "target.value"), this.props.dado, this.props.setDadosAgendamentoSemPensar);

        this.setState({
            iso: (event != null ? event.target.value : null)
        });

        if (await this.controller.ISOLiberaSobremedida(event.target.value)) {
            this.sobremedidaBloqueado = false;
        } else {
            this.sobremedidaBloqueado = true;
            this.props.setDado(`${this.props.dado}.OverdmsTop`, null);
            this.props.setDado(`${this.props.dado}.OverdmsDir`, null);
            this.props.setDado(`${this.props.dado}.OverdmsEsq`, null);
            this.props.setDado(`${this.props.dado}.OverdmsFre`, null);
            this.props.setDado(`${this.props.dado}.OverdmsTra`, null);
            this.controller.atualizaSobremedida = false;
            setTimeout(function () {
                this.controller.atualizaSobremedida = true;
            }.bind(this), 1);
        }
    };

    handleChangeTiposMercadoria = async (campo, event) => {
        let idTipo = event && event.value ? event.value : false;
        this.props.setDado(campo, event);

        await this.setState({
            tipoMercadoria: (event != null ? event.value : null)
        });

        await this.bookingController.changeTiposMercadoriaValor(this.props.dado,
            idTipo,
            this.props.setDadosAgendamentoSemPensar,
            this.parametrosStore.terminal,
            this.props.dadosMercadoria,
            this.props.container);


        await this.refresh();
    };

    refresh = () => {
        this.setState({ atualizado: false });
        setTimeout(function () {
            this.setState({ atualizado: true })
        }.bind(this), 1);
    };

    handleChangeTipoLacre = (dado, x, event) => {
        this.props.setDadosLacre(dado, event);
        this.revisaListasTiposLacres();
    };

    handleCampoChange = (event, campo, campoState, valor) => {
        this.props.setDado(`${this.props.dado}.${campo}`, event);

        this.setState({
            [campoState]: (event != null ? valor : null)
        });
    }

    handleExluiLacre = (x) => {
        this.props.removerLacre(x);
        this.revisaListasTiposLacres();
    };

    handleFlagsTran = (event) => {
        let value
        if (event) {
            value = "S"
        } else {
            value = "N"
        }
        this.controller.setTransitoAduaneiro(value)
        this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.FlgTran`, value)
        this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.FlgTranAduan`, value)
    }

    revisaListasTiposLacres = () => {
        setTimeout(function () {
            let lacres = _.get(this.props.container, `Lacres`);
            this.setState({ lacresMarcados: lacres.map(l => { return l.CdLacre }) });

            let tipos = this.bookingController.todosTiposDeLacre;
            for (let x = 0; x < 4; x++) {
                if (x < lacres.length)
                    this.bookingController.tiposDeLacre[x] = tipos.filter(tipo => (this.state.lacresMarcados.indexOf(tipo.value) === -1 || tipo.value === lacres[x].CdLacre));
                else
                    this.bookingController.tiposDeLacre[x] = tipos.filter(tipo => (this.state.lacresMarcados.indexOf(tipo.value) === -1));
            }
        }.bind(this), 500);
    };

    lacresTipos(x, disabled) {
        return <FormSelect xs={12} sm={12} md={6} xl={6} titulo="Tipo do lacre"
            itens={this.bookingController.tiposDeLacre[x]}
            objeto={this.props.container}
            dado={`Lacres[${x}].CdLacre`}
            itensValor="value" itensLabel="label"
            bloqueado={(x === 0) || this.props.isEditar? true : disabled}
            onChange={(event) => this.handleChangeTipoLacre(`${this.props.dado}.Lacres[${x}].CdLacre`, x, event)} />
    };

    lacres(x, disabled) {
        return <FormInputLacre titulo="Lacre" xs={12} sm={12} md={6} xl={6}
            objeto={this.props.container}
            dado={`Lacres[${x}].Lacre`}
            limiteMaximo={15}
            bloqueado={disabled}
            validacaoStore={this.props.validacaoLacres}
            onChange={(event) => this.props.setDadosLacre(`${this.props.dado}.Lacres[${x}].Lacre`, event)} />
    };

    colunaLacre(x, disabled) {
        if (this.props.container.Lacres.length > x)
            return <Col className="lacres card-form" xs={12} sm={12} md={6} xl={6}>
                <Row>
                    {this.parametrosStore.isAgendamentoVisible("ListaContainerTipoLacre") && this.lacresTipos(x, disabled)}
                    {this.parametrosStore.isAgendamentoEnabled("ListaContainerLacre") && this.lacres(x, disabled)}
                </Row>
                <div className="botao">
                    {(x > 0 || !this.props.isEditar) ? <IconeDelete className="icone-delete" tamanho="3x" onClick={() => this.handleExluiLacre(x)} /> : ""}
                </div>
            </Col>
    };

    mostraLacres() {
        if (this.props.atualizaLacres) {
            return <Row>
                {this.colunaLacre(0)}
                {this.colunaLacre(1)}
                {this.colunaLacre(2)}
                {this.colunaLacre(3)}
            </Row>
        }
    };

    campoISOs = () => {
        if (this.parametrosStore.terminal === "SSA") {
            return <FormSelect xs={12} sm={12} md={4} titulo="ISO"
                itens={this.bookingController.ISOs}
                objeto={this.props.container}
                dado={`CdIso`}
                itensValor="CdIso" itensLabel="CdIso"
                bloqueado={this.bookingController.ISOsBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerISO")  || this.props.isEditar}
                /*alerta={ (this.props.salvo) && 
                         (!valida(this.props.tipoAgenda, this.props.terminal, 'CdIso', 
                           this.state.iso) ? "Campo Obrigatório" : "") } */
                onChange={(event) => this.handleChangeISO(`${this.props.dado}.CdIso`, event)} />
        } 
            return this.bookingController.ISOsBloqueado && <FormInput titulo="ISO" xs={12} sm={12} md={4}
                objeto={this.props.container}
                dado={"CdIso"}
                bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerISO")}
                labelStatus={_.get(this.props.container, "valid.ISO_lblNaoExiste")}
                /*alerta={ (this.props.salvo) && 
                         (!valida(this.props.tipoAgenda, this.props.terminal, 'CdIso', 
                           this.state.iso) ? "Campo Obrigatório" : "") } */
                onChange={(event) => this.handleBlurISO(`${this.props.dado}.CdIso`, event)}
                onBlur={this.handleBlurNCM}
            />
    };

    alterarBloqueioTiposMercadoria = (tipo) => {
        this.bookingController.changeTiposMercadoria(this.props.dado, tipo, this.props.setDadosAgendamentoSemPensar, this.parametrosStore.terminal);
        this.refresh();
    };

    bloqueioTiposMercadoria(campo) {
        let result = true;
        const tipomercadoria = _.get(this.props.container, "CdTipoMerc");

        if (tipomercadoria != null) {
            if (this.props.terminal === "RIG") {
                switch (tipomercadoria) {
                    /** Resíduos Perigosos */
                    case 6:
                        result = !(campo === "IdUn");
                        break;
                    /** Refrigerada e Perigosa */
                    case 4:
                        result = false;
                        break;
                    /** Perigosa */
                    case 3:
                        result = !(campo === "IdUn");
                        break;
                    /** Refrigerada */
                    case 2:
                        result = (campo === "IdUn");
                        break;
                    /** Seca */
                    default:
                        result = true;
                        break;
                }
            }
        }
        return result;
    };

    alertaInfoContainer = () => {
        let alerta = (<div />);
        if (this.props.agendamentoController.exibeAlertaBookingNotas != null &&
            this.props.agendamentoController.exibeAlertaBookingNotas) {
            alerta = (
                <div className="card-atencao narrow float ">
                    <div className="d-flex w-100 justify-content-between align-items-center">
                        <div className="card-atencao--title">
                            Atenção!
                        </div>
                    </div>
                    <div className={this.classLabel}>
                        <p className="mb-0">
                            <label className="label-disabled">
                                {this.props.agendamentoController.alertaBookingNotas != null 
                                && this.props.agendamentoController.alertaBookingNotas.length > 0 
                                && this.props.agendamentoController.alertaBookingNotas.map(alerta =>
                                    <div>{alerta}</div>
                                )}
                            </label>
                        </p>
                    </div>
                </div>
            )
        }
        return alerta;
    }
   
    renderizarMensagem =()=>{                    
        document.getElementById("mensagemClienteCobrarDe").style.visibility = "visible";        
    }
    RemoverTextoDaTela=()=>{
        document.getElementById("mensagemClienteCobrarDe").style.visibility = "hidden";        
    }
    renderizarMensagemResponsavel =()=>{                    
        document.getElementById("mensagemResponsavelOva").style.visibility = "visible";        
    }
    RemoverTextoDaTelaResponsavel=()=>{
        document.getElementById("mensagemResponsavelOva").style.visibility = "hidden";        
    }
    renderizarPesoDocumental =()=>{                    
        document.getElementById("mensagemPesoDocumentacional").style.visibility = "visible";        
    }
    RemoverTextoPesoDocumental=()=>{
        document.getElementById("mensagemPesoDocumentacional").style.visibility = "hidden";        
    }
    render() {
        return (
            
            <Col className={this.props.hide ? "card-detalhes escondido" : "card-detalhes"} md={9}>
                
                <div className="titulo card-branco">
                    {/*this.alertaInfoContainer()*/}
                    <h2 className="mt-3">{_.get(this.props.container, "CodCntr") ? _.get(this.props.container, "CodCntr").toUpperCase() : ""}</h2>
                </div>
                
                <div className="area-form detalhes card-branco">
                
                    <Row>
                    <div id="mensagemPesoDocumentacional" class="alert alert-secondary" role="alert">
                    Notar que a informação do peso documental é utilizada para controle dos armadores e RFB. A informação deverá ser extraída da nota fiscal.
                    </div>
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerTipoCNTR") && this.parametrosStore.terminal === "SSA"
                            && <FormSelect xs={12} sm={12} md={4} titulo="Tipo"
                                bloqueado={!this.bookingController.tiposContainer || !this.parametrosStore.isAgendamentoEnabled("ListaContainerTipoCNTR") || this.props.isEditar}
                                itens={this.bookingController.tiposContainer}
                                objeto={this.props.container}
                                dado={"CdTipoCntr"}
                                itensValor="TpocntCdTipoCntr" itensLabel="TpocntDesc"
                                //alerta={ (this.props.salvo && !_.has(this.props.container, "CdTipoCntr")) ? "Campo obrigatório" : "" }
                                onChange={(event) => this.handleChangeTipoCntr(`${this.props.dado}.CdTipoCntr`, event)} />}
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerISO")
                            && this.campoISOs()}
                    </Row>             
                        
                    <Row>
                    <div id="mensagemClienteCobrarDe" class="alert alert-secondary" role="alert">
                    Incluir CNPJ do responsável pela carga importador/ exportador. Atenção: Essa informação poderá ser aplicada para emissão de faturas.
                    </div>
                    <div id="mensagemResponsavelOva" class="alert alert-secondary" role="alert">
                    Incluir o cnpj da empresa onde foi realizada a estufagem da carga.
                    </div>
                    
                    
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerCapacidadeMaxima")
                            && 
                                <FormInputNumber  titulo="Capacidade max" xs={12} sm={12} md={4}
                                    objeto={this.props.container}
                                    dado={"ValPesoMax"}
                                    bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerCapacidadeMaxima") }
                                    validador={isInvalidoTam5}
                                    limiteMaximo={5}
                                    /*alerta={ (this.props.salvo) && (!isInvalidoTam5) &&
                                            (!valida(this.props.tipoAgenda, this.props.terminal, 'ValPesoMax', 
                                            this.state.capacidademax) ? "Campo Obrigatório" : "") }       */
                                    onChange={(event) => { this.handleCampoChange(event, 'ValPesoMax', 'capacidademax', (event != null ? event.target.value : null)) }}
                                     />
                            }
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerPesoDocumental")
                            && <FormInputNumber titulo="Peso documental" xs={12} sm={12} md={4}
                                objeto={this.props.container}
                                dado={`ValPesoDoc`}
                                limiteMaximo={5}
                                bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerPesoDocumental")}
                                /*alerta={ (this.props.salvo) && 
                                    (!valida(this.props.tipoAgenda, this.props.terminal, 'ValPesoDoc', 
                                    this.state.pesodocumental) ? "Campo Obrigatório" : "") }  */  
                                tirarTextoDaTela= {()=>this.RemoverTextoPesoDocumental()}
                                renderizarTexto = {()=>this.renderizarPesoDocumental()}                                 
                                onChange={(event) => { this.handleCampoChange(event, 'ValPesoDoc', 'pesodocumental', (event != null ? event.target.value : null)) }}

                            />}
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerTara")
                            && <FormInputNumber titulo="Tara" xs={12} sm={12} md={4}
                                objeto={this.props.container}
                                dado={`ValTara`}
                                limiteMaximo={4}
                                /*alerta={ (this.props.salvo) && 
                                    (!valida(this.props.tipoAgenda, this.props.terminal, 'ValTara', 
                                     this.state.tara) ? "Campo Obrigatório" : "") }*/
                                bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerTara")}
                                onChange={(event) => { this.handleCampoChange(event, 'ValTara', 'tara', (event != null ? event.target.value : null)) }}
                            />}
                    </Row>
                    <Row>
                     
                       {this.parametrosStore.isAgendamentoVisible("ListaContainerCliente")
                            && <FormInput  
                                className="form-input imputClienteCobrar"  
                                titulo="Cliente" xs={12} sm={12} md={4}
                                objeto={this.props.container}
                                dado={`CnpjCliente`}
                                labelStatus={_.get(this.props.container, "valid.CnpjCliente_lblNaoExiste")}
                                bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerCliente")}
                                alerta={
                                    (this.props.salvo && !_.has(this.props.container, "ClibrsId") &&
                                        valida(this.props.tipoAgenda, this.props.terminal, 'CnpjCliente',
                                            this.state.cliente)) ? "Cliente não encontrado" : ""
                                }  
                                tirarTextoDaTela={() => this.RemoverTextoDaTela()}
                                renderizarTexto={() => this.renderizarMensagem()}
                                sanitizar={sanitizarCnpj}
                                limiteMaximo={14}
                                onChange={(event) => { 
                                    this.handleCampoChange(event, 'CnpjCliente', 'cliente', 
                                        (event != null ? event.target.value : null)) 
                                }}
                                onBlur={this.handleCarregarClientes} />}
                        {!this.bookingController.atualizandoClientes && this.parametrosStore.isAgendamentoVisible("ListaContainerCliente")
                            && <FormInput titulo="Razão Social 1" xs={12} sm={12} md={8}
                                bloqueado={true}
                                objeto={this.props.container}
                                dado={`RazSocialCliente`}
                                onChange={() => { }} />}
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerRespOvacao")
                            && <FormInput titulo="Resp. Ovação" xs={12} sm={12} md={4}
                                objeto={this.props.container}
                                dado={`CnpjRespOva`}
                                //labelStatus={_.get(this.props.container, "valid.CnpjRespOva_lblNaoExiste")}
                                tirarTextoDaTela={() => this.RemoverTextoDaTelaResponsavel()}
                                renderizarTexto={() => this.renderizarMensagemResponsavel()}
                                sanitizar={sanitizarCnpj}
                                limiteMaximo={14}
                                onChange={(event) => this.props.setDado(`${this.props.dado}.CnpjRespOva`, event)}
                                bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerRespOvacao")}
                                onBlur={this.handleCarregarRespOva} />}
                        {!this.bookingController.atualizandoRespOva && this.parametrosStore.isAgendamentoVisible("ListaContainerRespOvacao")
                            && <FormInput titulo="Razão Social 2" xs={12} sm={12} md={8}
                                bloqueado={process.env.ssa ? this.bookingController.bloqueadoRespOvacao[this.props.index]: true}
                                objeto={this.props.container}
                                dado={`RazSocialRespOva`}
                                onChange={(event) => { if (process.env.ssa) this.props.setDado(`${this.props.dado}.RazSocialRespOva`, event) }} />
                        }
                        {/**TODO incluir verificação do isAgendamentoVisible e do isAgendamentoEnabled; também incluir os dados de itens em controller */}
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerCategoria")
                            && <FormSelect id="" titulo="Categoria" xs={12} sm={12} md={4} className="mt-lg-1 mt-xl-1"
                                itens={this.bookingController.categorias}
                                objeto={this.props.container}
                                dado={"Categoria"}
                                itensValor="value" itensLabel="label"
                                /*alerta={ (this.props.salvo) && 
                                         (!valida(this.props.tipoAgenda, this.props.terminal, 'Categoria', 
                                          this.state.categoria) ? "Campo Obrigatório" : "") }*/
                                bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerCategoria") ||this.props.isEditar}
                                onChange={(event) => { this.handleCampoChange(event, 'Categoria', 'categoria', (event != null ? event.label : null)) }}
                            />}
                        {/**TODO incluir verificação do isAgendamentoVisible e do isAgendamentoEnabled*/}
                        {this.parametrosStore.isAgendamentoVisible("ListaContainerTransitoAduaneiro")
                            && <CheckboxField sm={12} md={12} widthAuto={true} className="mt-lg-1 mt-xl-1"
                                text={!process.env.rig ? "Trânsito aduaneiro" : "Marcar o flag somente em conclusão de trânsito"}
                                ativo={this.controller.transitoAduaneiroCheck}
                                
                                onClick={this.handleFlagsTran}
                            />}
                    </Row>

                    {this.parametrosStore.isAgendamentoVisible("ListaContainerLacre") && this.mostraLacres()}

                    <Row>
                        <Col md={3} sm={12}>
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerLacre") && <Label onClick={this.props.adicionarLacre} className="label-primary clicavel">Adicionar lacre</Label>}
                        </Col>
                    </Row>

                </div>

                {(this.parametrosStore.isAgendamentoVisible("ListaContainerAltura")
                    || this.parametrosStore.isAgendamentoVisible("ListaContainerAltura")
                    || this.parametrosStore.isAgendamentoVisible("ListaContainerDireita")
                    || this.parametrosStore.isAgendamentoVisible("ListaContainerFrente")
                    || this.parametrosStore.isAgendamentoVisible("ListaContainerTraseira"))
                    && this.controller.atualizaSobremedida && <div className="area-form detalhes card-branco">
                        <Row>
                            <Col>
                                <h2>Sobremedida (cm)</h2>
                            </Col>
                        </Row>
                        <Row>
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerAltura")
                                && <FormInputNumber titulo="Altura" xs={12} sm={12} md={4} col={!this.appStore.isMobile() ? "col-2-5" : false}
                                    objeto={this.props.container}
                                    dado={`OverdmsTop`}
                                    bloqueado={this.sobremedidaBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerAltura")}
                                    onChange={(event) => this.props.setDado(`${this.props.dado}.OverdmsTop`, event)} />}
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerDireita")
                                && <FormInputNumber titulo="Direita" xs={12} sm={12} md={4} col={!this.appStore.isMobile() ? "col-2-5" : false}
                                    objeto={this.props.container}
                                    dado={`OverdmsDir`}
                                    bloqueado={this.sobremedidaBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerDireita")}
                                    onChange={(event) => this.props.setDado(`${this.props.dado}.OverdmsDir`, event)} />}
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerEsquerda")
                                && <FormInputNumber titulo="Esquerda" xs={12} sm={12} md={4} col={!this.appStore.isMobile() ? "col-2-5" : false}
                                    objeto={this.props.container}
                                    dado={`OverdmsEsq`}
                                    bloqueado={this.sobremedidaBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerEsquerda")}
                                    onChange={(event) => this.props.setDado(`${this.props.dado}.OverdmsEsq`, event)} />}
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerFrente")
                                && <FormInputNumber titulo="Frente" xs={12} sm={12} md={4} col={!this.appStore.isMobile() ? "col-2-5" : false}
                                    objeto={this.props.container}
                                    dado={`OverdmsFre`}
                                    bloqueado={this.sobremedidaBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerFrente")}
                                    onChange={(event) => this.props.setDado(`${this.props.dado}.OverdmsFre`, event)} />}
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerTraseira")
                                && <FormInputNumber titulo="Traseira" xs={12} sm={12} md={4} col={!this.appStore.isMobile() ? "col-2-5" : false}
                                    objeto={this.props.container}
                                    dado={`OverdmsTra`}
                                    bloqueado={this.sobremedidaBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerTraseira")}
                                    onChange={(event) => this.props.setDado(`${this.props.dado}.OverdmsTra`, event)} />}
                        </Row>
                    </div>
                }

                {this.parametrosStore.isAgendamentoVisible("ListaContainerMercadoria")
                    && ((this.parametrosStore.isAgendamentoVisible("ListaContainerNCM") && this.props.ncmAtivo)
                        || this.parametrosStore.isAgendamentoVisible("ListaContainerTipoMercadoria")
                        || this.parametrosStore.isAgendamentoVisible("ListaContainerUmidade")
                        || this.parametrosStore.isAgendamentoVisible("ListaContainerVentilacao")
                        || this.parametrosStore.isAgendamentoVisible("ListaContainerTemperatura")
                        || this.parametrosStore.isAgendamentoVisible("ListaContainerUN"))

                    && <div className="area-form detalhes card-branco">
                        <Row>
                            <Col>
                                <h2>Mercadoria</h2>
                            </Col>
                        </Row>
                        {this.parametrosStore.terminal === "RIG" &&
                            this.controller.tipoAgenda &&
                            ![2].includes(this.controller.tipoAgenda.value) &&
                            <Row>
                                <Col>
                                    - A mercadoria será recuperada da Nota Fiscal.<br />
                                    - Para cargas / containers com Temperaura negativa é necessário acrescentar o sinal de negativo (- xx).
                                </Col>
                            </Row>
                        }
                        <Row>
                            {this.parametrosStore.isAgendamentoVisible("ListaContainerNCM") && this.props.ncmAtivo
                                && <FormInput titulo="NCM" xs={12} sm={12} md={4}
                                    obrigatorio={true}
                                    objeto={this.props.container}
                                    dado={`IdCommoditie`}
                                    labelStatus={_.get(this.props.container, "valid.NCM_lblNaoExiste")}
                                    onChange={(event) => this.props.setDado(`${this.props.dado}.IdCommoditie`, event)}
                                    bloqueado={!this.parametrosStore.isAgendamentoEnabled("ListaContainerNCM")}
                                    onBlur={this.handleBlurNCM} />}
                            {!this.bookingController.atualizandoNcm && this.parametrosStore.isAgendamentoVisible("ListaContainerNCM") && this.props.ncmAtivo
                                && <FormInput titulo="Descrição" xs={12} sm={12} md={8}
                                    objeto={this.props.container}
                                    dado={`NCM_descricaoMercadoria`}
                                    bloqueado={true}
                                    onChange={() => { }} />} 
                        </Row>
                        <Row>
                            {this.state.atualizado && this.parametrosStore.isAgendamentoVisible("ListaContainerTipoMercadoria")
                                && <FormSelect xs={12} sm={12} md={6} titulo="Tipo"
                                    itens={this.controller.tiposMercadoria}
                                    objeto={this.props.container}
                                    dado={`CdTipoMerc`}
                                    itensValor="CdTipoMerc" itensLabel="DscMerc"
                                    /*alerta={ (this.props.salvo) && 
                                             (!valida(this.props.tipoAgenda, this.props.terminal, 'CdTipoMerc', 
                                              this.state.tipoMercadoria) ? "Campo Obrigatório" : "") }*/
                                    bloqueado={this.controller.tiposMercadoriaBloqueado || !this.parametrosStore.isAgendamentoEnabled("ListaContainerTipoMercadoria")}
                                    onChange={(event) => { this.handleChangeTiposMercadoria(`${this.props.dado}.CdTipoMerc`, event) }}
                                />}
                        </Row>
                        <Row>
                            {this.state.atualizado && this.parametrosStore.isAgendamentoVisible("ListaContainerUmidade")
                                && <FormInputNumber titulo="Umidade" xs={12} sm={12} md={3}
                                    objeto={this.props.container}
                                    permiteValorNegativo={true}
                                    dado={`ValUmid`}
                                    bloqueado={this.bloqueioTiposMercadoria(`ValUmid`)
                                        || !this.parametrosStore.isAgendamentoEnabled("ListaContainerUmidade") || this.props.isEditar
                                    }
                                    onChange={(event) => { this.props.setDado(`${this.props.dado}.ValUmid`, event) }} />}
                            {this.state.atualizado && this.parametrosStore.isAgendamentoVisible("ListaContainerVentilacao")
                                && <FormInputNumber titulo="Ventilação" xs={12} sm={12} md={3}
                                    objeto={this.props.container}
                                    permiteValorNegativo={true}
                                    dado={`ValVent`}
                                    bloqueado={this.bloqueioTiposMercadoria(`ValVent`)
                                        || !this.parametrosStore.isAgendamentoEnabled("ListaContainerVentilacao") || this.props.isEditar
                                    }
                                    onChange={(event) => { this.props.setDado(`${this.props.dado}.ValVent`, event) }} />}
                            {this.state.atualizado && this.parametrosStore.isAgendamentoVisible("ListaContainerTemperatura")
                                && <FormInputNumber titulo="Temperatura" xs={12} sm={12} md={3}
                                    objeto={this.props.container}
                                    permiteValorNegativo={true}
                                    dado={`ValTmpIdea`}
                                    bloqueado={this.bloqueioTiposMercadoria(`ValTmpIdea`)
                                        || !this.parametrosStore.isAgendamentoEnabled("ListaContainerTemperatura") || this.props.isEditar
                                    }
                                    onChange={(event) => { this.props.setDado(`${this.props.dado}.ValTmpIdea`, event) }} />}
                            {this.state.atualizado && this.parametrosStore.isAgendamentoVisible("ListaContainerUN")
                                && <FormInputNumber titulo="UN" xs={12} sm={12} md={3}
                                    objeto={this.props.container}
                                    dado={`IdUn`}
                                    bloqueado={this.bloqueioTiposMercadoria(`IdUn`)
                                        || !this.parametrosStore.isAgendamentoEnabled("ListaContainerUN") || this.props.isEditar
                                    }
                                    onChange={(event) => { this.props.setDado(`${this.props.dado}.IdUn`, event) }} />}
                        </Row>
                    </div>}
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/components/CardBookingContainers.js